import { ICampaignDetailItem } from "../CreateCertificationStepOne/module/constants";

export const actionTypes = {
  SET_CAMPAIGN_DETAIL: "SET_CAMPAIGN_DETAIL",

  SUPERVISORS_REQUEST: "SUPERVISORS_REQUEST",
  SUPERVISORS_REQUEST_SUCCESS: "SUPERVISORS_REQUEST_SUCCESS",
  SUPERVISORS_REQUEST_FAILURE: "SUPERVISORS_REQUEST_FAILURE",

  SET_ADDED_SUPERVISORS: "SET_ADDED_SUPERVISORS",

  REVISOR_REQUEST: "REVISOR_REQUEST",
  REVISOR_REQUEST_SUCCESS: "REVISOR_REQUEST_SUCCESS",
  REVISOR_REQUEST_FAILURE: "REVISOR_REQUEST_FAILURE",

  SET_REVISOR_SELECTED: "SET_REVISOR_SELECTED",

  SET_CAMPAIGN_TIME: "SET_CAMPAIGN_TIME",

  GROUPS_PERIMETER_REQUEST: "GROUPS_PERIMETER_REQUEST",
  GROUPS_PERIMETER_REQUEST_SUCCESS: "GROUPS_PERIMETER_REQUEST_SUCCESS",
  GROUPS_PERIMETER_REQUEST_FAILURE: "GROUPS_PERIMETER_REQUEST_FAILURE",

  SET_ADDED_GROUPS_PERIMETER: "SET_ADDED_GROUPS_PERIMETER",

  APPLICATIONS_PERIMETER_REQUEST: "APPLICATIONS_PERIMETER_REQUEST",
  APPLICATIONS_PERIMETER_REQUEST_SUCCESS:
    "APPLICATIONS_PERIMETER_REQUEST_SUCCESS",
  APPLICATIONS_PERIMETER_REQUEST_FAILURE:
    "APPLICATIONS_PERIMETER_REQUEST_FAILURE",

  SET_ADDED_APPLICATIONS_PERIMETER: "SET_ADDED_APPLICATIONS_PERIMETER",

  USERS_PERIMETER_REQUEST: "USERS_PERIMETER_REQUEST",
  USERS_PERIMETER_REQUEST_SUCCESS: "USERS_PERIMETER_REQUEST_SUCCESS",
  USERS_PERIMETER_REQUEST_FAILURE: "USERS_PERIMETER_REQUEST_FAILURE",

  SET_ADDED_USERS_PERIMETER: "SET_ADDED_USERS_PERIMETER",

  BR_PERIMETER_REQUEST: "BR_PERIMETER_REQUEST",
  BR_PERIMETER_REQUEST_SUCCESS: "BR_PERIMETER_REQUEST_SUCCESS",
  BR_PERIMETER_REQUEST_FAILURE: "BR_PERIMETER_REQUEST_FAILURE",

  SET_ADDED_BR_PERIMETER: "SET_ADDED_BR_PERIMETER",

  ENTITLEMENTS_PERIMETER_REQUEST: "ENTITLEMENTS_PERIMETER_REQUEST",
  ENTITLEMENTS_PERIMETER_REQUEST_SUCCESS:
    "ENTITLEMENTS_PERIMETER_REQUEST_SUCCESS",
  ENTITLEMENTS_PERIMETER_REQUEST_FAILURE:
    "ENTITLEMENTS_PERIMETER_REQUEST_FAILURE",

  SET_ADDED_ENTITLEMENTS_PERIMETER: "SET_ADDED_ENTITLEMENTS_PERIMETER",

  TECHNICAL_USERS_PERIMETER_REQUEST: "TECHNICAL_USERS_PERIMETER_REQUEST",
  TECHNICAL_USERS_PERIMETER_REQUEST_SUCCESS:
    "TECHNICAL_USERS_PERIMETER_REQUEST_SUCCESS",
  TECHNICAL_USERS_PERIMETER_REQUEST_FAILURE:
    "TECHNICAL_USERS_PERIMETER_REQUEST_FAILURE",

  SET_ADDED_TECHNICAL_USERS: "SET_ADDED_TECHNICAL_USERS",

  SET_TAB_SELECTED: "SET_TAB_SELECTED",

  SET_TRIGGER_CONFIRM_MODAL_CREATE_CERTIFICATION:
    "SET_TRIGGER_CONFIRM_MODAL_CREATE_CERTIFICATION",

  CREATE_CERTIFICATION_REQUEST: "CREATE_CERTIFICATION_REQUEST",
  CREATE_CERTIFICATION_REQUEST_SUCCESS: "CREATE_CERTIFICATION_REQUEST_SUCCESS",
  CREATE_CERTIFICATION_REQUEST_FAILURE: "CREATE_CERTIFICATION_REQUEST_FAILURE",

  EDIT_CERTIFICATION_REQUEST: "EDIT_CERTIFICATION_REQUEST",
  EDIT_CERTIFICATION_REQUEST_SUCCESS: "EDIT_CERTIFICATION_REQUEST_SUCCESS",
  EDIT_CERTIFICATION_REQUEST_FAILURE: "EDIT_CERTIFICATION_REQUEST_FAILURE",

  RESET_PERIMETERS_CREATE_CERTIFICATION:
    "RESET_PERIMETERS_CREATE_CERTIFICATION",

  SET_SELECTED_CERTIFICATION_FROM_CONSOLE_ADMIN_TO_CREATE_CAMPAIGN:
    "SET_SELECTED_CERTIFICATION_FROM_CONSOLE_ADMIN_TO_CREATE_CAMPAIGN",

  SET_SELECTED_CERTIFICATION_ENRICHMENT_FROM_CONSOLE_ADMIN_TO_CREATE_CAMPAIGN:
    "SET_SELECTED_CERTIFICATION_ENRICHMENT_FROM_CONSOLE_ADMIN_TO_CREATE_CAMPAIGN",

  RESET_STATE_CREATE_EDIT_CERTIFICATION:
    "RESET_STATE_CREATE_EDIT_CERTIFICATION",

  SET_ALREADY_SET: "SET_ALREADY_SET",
};

export const resetStateCreateEditCertification = () => ({
  type: actionTypes.RESET_STATE_CREATE_EDIT_CERTIFICATION,
});

export const setSelectedCertificationFromConsoleAdminToCreateCampaign = (
  payload: any
) => ({
  type: actionTypes.SET_SELECTED_CERTIFICATION_FROM_CONSOLE_ADMIN_TO_CREATE_CAMPAIGN,
  payload,
});

export const setSelectedCertificationEnrichmentFromConsoleAdminToCreateCampaign =
  (payload: any) => ({
    type: actionTypes.SET_SELECTED_CERTIFICATION_ENRICHMENT_FROM_CONSOLE_ADMIN_TO_CREATE_CAMPAIGN,
    payload,
  });

export const resetPerimeters = () => ({
  type: actionTypes.RESET_PERIMETERS_CREATE_CERTIFICATION,
});

export const setTriggerConfirmModal = (payload: any) => ({
  type: actionTypes.SET_TRIGGER_CONFIRM_MODAL_CREATE_CERTIFICATION,
  payload,
});

export const setTabSelected = (payload: any, tab: string) => ({
  type: actionTypes.SET_TAB_SELECTED,
  payload,
  tab,
});

export const setCampaignDetail = (payload: ICampaignDetailItem) => ({
  type: actionTypes.SET_CAMPAIGN_DETAIL,
  payload,
});

export const setAddedSupervisors = (payload: any) => ({
  type: actionTypes.SET_ADDED_SUPERVISORS,
  payload,
});

export const supervisorsRequest = (payload: any | null) => ({
  type: actionTypes.SUPERVISORS_REQUEST,
  payload,
});

export const supervisorsRequestSuccess = (payload: any) => ({
  type: actionTypes.SUPERVISORS_REQUEST_SUCCESS,
  payload,
});

export const supervisorsRequestFailure = (error: Error) => ({
  type: actionTypes.SUPERVISORS_REQUEST_FAILURE,
  error,
});

export const revisorRequest = (payload: any | null) => ({
  type: actionTypes.REVISOR_REQUEST,
  payload,
});

export const revisorRequestSuccess = (payload: any) => ({
  type: actionTypes.REVISOR_REQUEST_SUCCESS,
  payload,
});

export const revisorRequestFailure = (error: Error) => ({
  type: actionTypes.REVISOR_REQUEST_FAILURE,
  error,
});

export const setRevisorSelected = (payload: any) => ({
  type: actionTypes.SET_REVISOR_SELECTED,
  payload,
});

export const setCampaignTime = (payload: any) => ({
  type: actionTypes.SET_CAMPAIGN_TIME,
  payload,
});

export const groupsPerimeterRequest = (payload: any | null) => ({
  type: actionTypes.GROUPS_PERIMETER_REQUEST,
  payload,
});

export const groupsPerimeterRequestSuccess = (payload: any) => ({
  type: actionTypes.GROUPS_PERIMETER_REQUEST_SUCCESS,
  payload,
});

export const groupsPerimeterRequestFailure = (error: Error) => ({
  type: actionTypes.GROUPS_PERIMETER_REQUEST_FAILURE,
  error,
});

export const applicationsPerimeterRequest = (payload: any | null) => ({
  type: actionTypes.APPLICATIONS_PERIMETER_REQUEST,
  payload,
});

export const applicationsPerimeterRequestSuccess = (payload: any) => ({
  type: actionTypes.APPLICATIONS_PERIMETER_REQUEST_SUCCESS,
  payload,
});

export const applicationsPerimeterRequestFailure = (error: Error) => ({
  type: actionTypes.APPLICATIONS_PERIMETER_REQUEST_FAILURE,
  error,
});

export const usersPerimeterRequest = (payload: any | null) => ({
  type: actionTypes.USERS_PERIMETER_REQUEST,
  payload,
});

export const usersPerimeterRequestSuccess = (payload: any) => ({
  type: actionTypes.USERS_PERIMETER_REQUEST_SUCCESS,
  payload,
});

export const usersPerimeterRequestFailure = (error: Error) => ({
  type: actionTypes.USERS_PERIMETER_REQUEST_FAILURE,
  error,
});

export const brPerimeterRequest = (payload: any | null) => ({
  type: actionTypes.BR_PERIMETER_REQUEST,
  payload,
});

export const brPerimeterRequestSuccess = (payload: any) => ({
  type: actionTypes.BR_PERIMETER_REQUEST_SUCCESS,
  payload,
});

export const brPerimeterRequestFailure = (error: Error) => ({
  type: actionTypes.BR_PERIMETER_REQUEST_FAILURE,
  error,
});

export const entitlementsPerimeterRequest = (payload: any | null) => ({
  type: actionTypes.ENTITLEMENTS_PERIMETER_REQUEST,
  payload,
});

export const entitlementsPerimeterRequestSuccess = (payload: any) => ({
  type: actionTypes.ENTITLEMENTS_PERIMETER_REQUEST_SUCCESS,
  payload,
});

export const entitlementsPerimeterRequestFailure = (error: Error) => ({
  type: actionTypes.ENTITLEMENTS_PERIMETER_REQUEST_FAILURE,
  error,
});

export const technicalUsersPerimeterRequest = (payload: any | null) => ({
  type: actionTypes.TECHNICAL_USERS_PERIMETER_REQUEST,
  payload,
});

export const technicalUsersPerimeterRequestSuccess = (payload: any) => ({
  type: actionTypes.TECHNICAL_USERS_PERIMETER_REQUEST_SUCCESS,
  payload,
});

export const technicalUsersPerimeterRequestFailure = (error: Error) => ({
  type: actionTypes.TECHNICAL_USERS_PERIMETER_REQUEST_FAILURE,
  error,
});

export const setAddedGroupsPerimeter = (payload: any) => ({
  type: actionTypes.SET_ADDED_GROUPS_PERIMETER,
  payload,
});

export const setAddedUsersPerimeter = (payload: any) => ({
  type: actionTypes.SET_ADDED_USERS_PERIMETER,
  payload,
});

export const setAddedApplicationsPerimeter = (payload: any) => ({
  type: actionTypes.SET_ADDED_APPLICATIONS_PERIMETER,
  payload,
});

export const setAddedBrPerimeter = (payload: any) => ({
  type: actionTypes.SET_ADDED_BR_PERIMETER,
  payload,
});

export const setAddedEntitlementsPerimeter = (payload: any) => ({
  type: actionTypes.SET_ADDED_ENTITLEMENTS_PERIMETER,
  payload,
});

export const setAddedTechnicalUsersPerimeter = (payload: any) => ({
  type: actionTypes.SET_ADDED_TECHNICAL_USERS,
  payload,
});

export const createCertificationRequest = (payload: any | null) => ({
  type: actionTypes.CREATE_CERTIFICATION_REQUEST,
  payload,
});

export const createCertificationRequestSuccess = (payload: any) => ({
  type: actionTypes.CREATE_CERTIFICATION_REQUEST_SUCCESS,
  payload,
});

export const createCertificationRequestFailure = (error: Error) => ({
  type: actionTypes.CREATE_CERTIFICATION_REQUEST_FAILURE,
  error,
});

export const editCertificationRequest = (payload: any | null) => ({
  type: actionTypes.EDIT_CERTIFICATION_REQUEST,
  payload,
});

export const editCertificationRequestSuccess = (payload: any) => ({
  type: actionTypes.EDIT_CERTIFICATION_REQUEST_SUCCESS,
  payload,
});

export const editCertificationRequestFailure = (error: Error) => ({
  type: actionTypes.EDIT_CERTIFICATION_REQUEST_FAILURE,
  error,
});

export const setAlreadySet = (payload: boolean) => ({
  type: actionTypes.SET_ALREADY_SET,
  payload,
});
